import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _forEachInstanceProperty from "@babel/runtime-corejs3/core-js/instance/for-each";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/esm/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var _context, _context2; var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? _forEachInstanceProperty(_context = ownKeys(Object(t), !0)).call(_context, function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : _forEachInstanceProperty(_context2 = ownKeys(Object(t))).call(_context2, function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
import _includesInstanceProperty from "@babel/runtime-corejs3/core-js/instance/includes";
import dateTimeToWords from "./dateTimeToWords.js";
var formats = {
  short: {
    month: 'numeric',
    day: 'numeric',
    year: 'numeric'
  },
  natural: {
    month: 'long',
    day: 'numeric',
    year: 'numeric'
  },
  weekday: {
    weekday: 'long',
    month: 'long',
    day: 'numeric',
    year: 'numeric'
  },
  verbose: {},
  ornate: {},
  verboseDateOnly: {},
  ornateDateOnly: {},
  hoursMinutes: {
    hour: 'numeric',
    minute: 'numeric'
  }
};
var wordyFormats = ['verbose', 'verboseDateOnly', 'ornate', 'ornateDateOnly'];
var localizedFormats = ['short', 'hoursMinutes'];
export var defaultFormat = 'natural';
export default function dateTimeFormatted(datetime) {
  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : defaultFormat;
  if (!datetime) return null;
  var date;
  if (typeof datetime === 'string') {
    var dateString = datetime;
    if (dateString.match(/\d\d:\d\d:\d\d/)) {
      dateString = "".concat(dateString, " GMT");
    }
    date = new Date(dateString);
  } else {
    date = datetime;
  }
  var formattedDate = '';
  var wordyFormat = _includesInstanceProperty(wordyFormats).call(wordyFormats, format);
  if (!wordyFormat) {
    var options = _objectSpread({
      timeZone: 'UTC'
    }, formats[format]);
    var localizedFormat = _includesInstanceProperty(localizedFormats).call(localizedFormats, format);
    var locale = localizedFormat ? undefined : 'en-US';
    formattedDate = date.toLocaleString(locale, options).replace(/\//g, '.');
  } else {
    var templates = {
      verbose: "%E, %M %d, %y at %HW%MW O'Clock",
      verboseDateOnly: '%E, %M %d, %y',
      ornate: "%E, %M %DOW, %YW at %HW%MW O'Clock %bw",
      ornateDateOnly: '%E, %M %DOW, %YW'
    };
    if (date instanceof Date && !isNaN(date.valueOf()) && isFinite(date.valueOf())) {
      formattedDate = dateTimeToWords(date, templates[format]);
    }
  }
  return formattedDate;
}